import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { HelpersService } from 'src/app/services/helpers.service';


@Component({
  selector: 'app-workshop-jobcard-pre-service-checks',
  templateUrl: './workshop-jobcard-pre-service-checks.component.html',
  styleUrls: ['./workshop-jobcard-pre-service-checks.component.scss']
})
export class WorkshopJobcardPreServiceChecksComponent {

  @Input() jobcard: any;
  @Input() preServiceChecklist: any[] = [];


  public checklist: any = [];
  public updating: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private translate: TranslateService,
    private helpersService: HelpersService
  ) { }

  ngOnInit() {
    this.checklist = this.preServiceChecklist.sort((a: any, b: any) => {
      if (a.labelColour && b.labelColour) {
        return a.labelColour.localeCompare(b.labelColour);
      }
      return 0;
    }).sort((a: any, b: any) => {
      if (a.controlType && !b.controlType) {
        return -1; // a comes first
      } else if (!a.controlType && b.controlType) {
        return 1; // b comes first
      }
      return 0;
    });
  }

  done() {
    this.activeModal.close(this.checklist);
  }

  @HostListener('document:keydown.enter', ['$event'])
  handleEnter(event: KeyboardEvent) {
    this.done();
  }

  getColor(colour: string): string {
    if (colour) {
      const hex = colour.replace('#', '');
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      return `rgba(${r}, ${g}, ${b}, 0.2)`;
    } else {
      return 'rgba(0, 0, 0, 0.2)'; // Default color if no colour is provided
    }

  }

  hasCheckedItems(): boolean {
    return this.checklist.some((item: any) => {
      return item.controlType === 'CHECKBOX' && (item.defaultValue === true || item.frontValue === true || item.rearValue === true);
    });
  }

  checkAllBoxes() {
    this.checklist.forEach((item: any) => {
      if (item.controlType === 'CHECKBOX') {
        if (item.frontRearCheck) {
          item.frontValue = true;
          item.rearValue = true;
        } else {
          item.defaultValue = true;
        }
      }
    });
  }
  uncheckAllBoxes() {
    this.checklist.forEach((item: any) => {
      if (item.controlType === 'CHECKBOX') {
        if (item.frontRearCheck) {
          item.frontValue = false;
          item.rearValue = false;
        } else {
          item.defaultValue = false;
        }
      }
    });
  }

}
